import Vue from "vue";
import App from "./App.vue";
import router from "./router/index";
import { Toast } from 'vant';
import '@/assets/css/reset.css'
import VueCompositionApi from '@vue/composition-api'

Vue.config.productionTip = false;


// Vue.prototype.$share = wechatShare
Vue.use(VueCompositionApi)
Vue.use(Toast);
require('@/common/common.js')

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
